import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PAYMENT_TYPE, PAYMENT_TYPE_LABELS } from "common/utils/constants"
import { Tooltip } from "primereact/tooltip"
import { useTranslation } from "react-i18next"

const StatusTooltip = ({
  estado,
  iconColor = "#212121",
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div
      key='estado2'
      className='cartera_column-header'
    >
      <span>
        {t("crear.factura.paymentStatus")}{" "}
        {estado === PAYMENT_TYPE.COBRO
          ? PAYMENT_TYPE_LABELS(t)[2]
          : PAYMENT_TYPE_LABELS(t)[1]}
      </span>
      <Tooltip
        target='.tooltip-info'
        content='Este estado es únicamente informativo según la gestión de pagos y cobros del otro interviniente en la operación'
        position='bottom'
        className='tooltip-cartera-header'
      />
      <span className='tooltip-info'>
        <FontAwesomeIcon
          icon={["fal", "circle-info"]}
          style={{ color: iconColor }}
        />
      </span>
    </div>
  )
}

export default StatusTooltip
